import React from "react";

function SimFix() {
  var user = JSON.parse(localStorage.getItem("user")) || {};
  var link =
    process.env.REACT_APP_SIMFIX_LINK +
    "?auth_token=" +
    localStorage.getItem("authToken")
    + "&client_type=" + user.sim_fix_client[0]
  return (
    <iframe
      src={link}
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        position: "absolute",
        top: 0,
        right: 0,
      }}
    />
  );
}

export default SimFix;
